<template>
    <div class="main">
        <div class="title">
            <h4>{{ teamStore.getTeamName }}</h4>
        </div>
        <div class="row space-between">
            <div>
                <input v-model="state.story.heading" type="text" placeholder="Choose a Title" width="300" />
            </div>
            <div class="buttons">
                <router-link :to="{ name: 'Detail', params: { id: id } }">
                    <button class="danger-button bt" title="Discard">
                        <font-awesome-icon :icon="['fas', 'times']" />
                    </button>
                </router-link>
                <button @click="save" class="action-button" title="Save">
                    <font-awesome-icon :icon="['fas', 'save']" />
                </button>
            </div>
        </div>
        <div class="text-editor">
            <TextEditorSkeleton v-if="state.loading" :showToolbar="true" />
            <RichTextBox v-else v-model="state.story.body" />
        </div>
    </div>
</template>

<script setup lang="ts">
import RichTextBox from "@/components/RichTextBox.vue";
import router from "@/router";
import { TeamStory } from "@/services/entities/teamStory";
import { useTeamStore } from "@/stores/team";
import { useTeamStoryStore } from "@/stores/teamStory";
import { onMounted, reactive } from "vue";
import { onBeforeRouteLeave } from "vue-router";
import { toast } from "vue3-toastify";
import TextEditorSkeleton from "@/components/util/TextEditorSkeleton.vue";

const teamStoryStore = useTeamStoryStore();
const teamStore = useTeamStore();

const { id } = defineProps<{
    id: string;
}>();

const state = reactive({
    saved: false,
    loading: true,
    story: { heading: "", body: "" } as any as TeamStory,
});

const oldStory = { heading: "", body: "" };

async function save() {
    const t = toast.loading("Saving...");
    try {
        if (state.story.id) {
            await teamStoryStore.updateTeamStory(state.story);
        } else {
            toast.error("No story to save.");
            return;
        }
    } catch (error) {
        console.log("Error saving story:", error);
        toast.remove(t);
        toast.error("Error saving story.");
        return;
    }
    state.saved = true;
    toast.remove(t);
    toast.success("Saved!");
    setTimeout(() => {
        router.push({ name: "Home" });
    }, 1000);
}

onBeforeRouteLeave((to, from, next) => {
    if (!state.saved && !confirm("Discard changes?")) {
        next(false);
    } else {
        next();
    }
});

onMounted(async () => {
    if (id) {
        state.loading = true;
        if (teamStoryStore.getTeamStories.length === 0) {
            await teamStoryStore.loadRecord(id);
        }
        const result = teamStoryStore.getTeamStories.find((story) => story.id === id);
        if (result) {
            state.story = result;
            oldStory.heading = result.heading;
            oldStory.body = result.body;
        }
        state.loading = false;
    }
});
</script>

<style lang="scss" scoped>
.main {
    display: flex;
    flex-direction: column;
    padding-top: 30px;
}

.text-editor {
    margin-top: 5px;
    width: 100%;
    height: 100%;
}

.buttons {
    display: flex;
    gap: 10px;
    padding-right: 3px;
}
.row {
    display: flex;
    flex-direction: row;
    width: 100%;

    &.space-between {
        justify-content: space-between;
    }
}

.row-right {
    display: flex;
    margin-top: 10px;
    align-items: right;
    justify-content: right;
}

.bt {
    margin-right: 5px;
}
</style>
